// extracted by css-extract-rspack-plugin
export default {"required":"Required_required__r6gXH"};